define('TescoMobile_Checkout/js/view/subtotals/totals',['ko', 'uiComponent', 'Magento_Customer/js/customer-data', 'Magento_Checkout/js/model/totals', 'Magento_Checkout/js/model/quote', 'Magento_Catalog/js/price-utils'], function (ko, Component, customerData, totals, quote, priceUtils) {
  'use strict';

  return Component.extend({
    displaySubtotal: ko.observable(true),
    totals: quote.getTotals(),
    initialize: function () {
      this._super();
      this.cart = customerData.get('cart');
    },
    getValue: function () {
      var price = 0;
      if (this.totals()) {
        price = totals.getSegment('discount') ? Math.abs(totals.getSegment('discount').value) : 0;
        if (totals.getSegment('giftcardaccount')) {
          price += Math.abs(totals.getSegment('giftcardaccount').value);
        }
      }
      return this.getFormattedPrice(price);
    },
    getFormattedPrice: function (price) {
      return priceUtils.formatPrice(price, quote.getPriceFormat());
    }
  });
});

